var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Retriever {
    constructor(connection, regionCode, sportConfigs) {
        this.NumberOfPersonalizedEvents = 5;
        this.connection = connection;
        this.regionCode = regionCode;
        this.orderedSportIds = sportConfigs
            .sort((x, y) => x.order - y.order)
            .map(x => `${x.sportId}`);
    }
    getData(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                query,
                sportIds: this.orderedSportIds
            };
            return yield this.connection.search(request);
        });
    }
    getPersonalizedData() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                numberOfEvents: this.NumberOfPersonalizedEvents,
                regionCode: this.regionCode,
                ids: this.orderedSportIds,
                includeFields: ["Events"]
            };
            return yield this.connection.personalizedEvents(request);
        });
    }
    saveRecents(recents) {
        const data = recents.map(recent => ({
            type: recent.type,
            id: recent.id,
            sportId: recent.sportId,
            timestamp: recent.timestamp
        }));
        localStorage.setItem("BetSearchRecents", JSON.stringify(data));
    }
    getRecents() {
        const data = localStorage.getItem("BetSearchRecents");
        return data ? JSON.parse(data) : [];
    }
    getEvents(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                ids,
                excludeMarkets: true
            };
            return yield this.connection.getEvents(request);
        });
    }
    getLeagues(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                ids
            };
            return yield this.connection.getLeagues(request);
        });
    }
}
//# sourceMappingURL=Retriever.js.map